/** @jsxImportSource theme-ui */

type Props = {
  fill?: string;
};

const IconProjectAC = ({ fill = "white", ...props }: Props) => (
  <svg viewBox="0 0 450 400" fill="none" {...props}>
    <path
      d="M294.649 0H154.815c-28.319 0-51.28 20.489-51.28 45.76v308.48c0 25.271 22.961 45.76 51.28 45.76h139.834c28.319 0 51.28-20.489 51.28-45.76V45.749C345.929 20.478 322.968 0 294.649 0zm-69.917 267.384c-41.706 0-75.52-30.173-75.52-67.389 0-37.217 33.814-67.39 75.52-67.39 41.706 0 75.52 30.173 75.52 67.39 0 37.216-33.814 67.389-75.52 67.389zM0 132.605c41.706 0 75.52 30.173 75.52 67.389 0 37.217-33.814 67.39-75.52 67.39M450 134.193c-40.963 0-74.18 29.64-74.18 66.193 0 36.554 33.217 66.194 74.18 66.194"
      sx={{ fill }}
    />
  </svg>
);

export default IconProjectAC;
